import { useCallback, useContext } from 'react';
import getIdentifier from '../../../../getIdentifier';
import getTimeStamp from '../../../../getTimeStamp';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import CurrentUserContext from '../../../../contexts/CurrentUserContext';

const useCreateScorecardCopy = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const currentUser = useContext(CurrentUserContext);

  const createScorecardCopy = useCallback(
    async ({
      title,
      scorecard,
    }: {
      title: string;
      scorecard: Scorecards.Scorecard;
    }): Promise<{
      newScorecard: Scorecards.Scorecard;
      newScorecardId: string;
    }> => {
      const newScorecard: Scorecards.Scorecard = {
        ...scorecard,
        title,
        id: getIdentifier(),
        createdBy: currentUser.id,
        createdOn: getTimeStamp(),
        updatedBy: currentUser.id,
        updatedOn: getTimeStamp(),
      };

      await STORE.visualisations
        .getScorecardsRef({
          accountId: selectedAccountId,
        })
        .doc(newScorecard.id)
        .set(newScorecard);

      return {
        newScorecardId: newScorecard.id,
        newScorecard,
      };
    },
    [currentUser.id, selectedAccountId],
  );

  return createScorecardCopy;
};

export default useCreateScorecardCopy;
